import { validationIsEqual } from '../status';
import {
    validateDateOfBirth,
    validateEmail,
    validateName,
    validateContactNumber,
    validateSingleSelection,
    validateNumber,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateAlphaNumericString,
    validateKraPinNumber,
    validateKeCarRegNumber,
    validateNumericString,
    validateAlphaString,
    validatePassportNumber,
    validateBase64File,
} from '@om/validation';
import {
    TITLE_SET_VALUE,
    FULL_NAME_SET_VALUE,
    ID_TYPE_SET_VALUE,
    DOB_SET_VALUE,
    AGE_BAND_SET_VALUE,
    ID_NUMBER_SET_VALUE,
    KRA_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALUE,
    EMAIL_SET_VALUE,
    setIdNumberValid,
    setIdTypeValid,
    setFullNameValid,
    setEmailValid,
    setPhoneNumberValid,
    setDOBValid,
    setAgeBandValid,
    setKraNumberValid,
    setTitleValid,
    FULL_NAME_EMERGENCY_SET_VALUE,
    PHONE_NUMBER_EMERGENCY_SET_VALUE,
    EMAIL_EMERGENCY_SET_VALUE,
    setFullNameEmergencyValid,
    setPhoneNumberEmergencyValid,
    setEmailEmergencyValid,
    PASSPORT_SET_VALUE,
    setPassportValid,
    REFERRED_SET_VALUE,
    setReferredValid,
    ID_DOC_SET_VALUE,
    setIdDocValid,
    KRA_PIN_DOC_SET_VALUE,
    setKraPinValid,
    setPassportDocValid,
    PASSPORT_DOC_SET_VALUE,
} from '../../../actions/travelKe/personalDetails';

let prevValidationAction = null;
export const travelDetailsValidation = (store, next, action) => {
    const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

    const validationAction = (() => {
        let error;
        switch (action.type) {
            case TITLE_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Title',
                });
                return setTitleValid(error);

            case FULL_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'Full Name',
                });
                return setFullNameValid(error);

            // case ID_TYPE_SET_VALUE:
            //     error = validateSingleSelection(action.value, {
            //         subjet: 'ID TYPE',
            //     });
            //     return setIdTypeValid(error);

            case ID_NUMBER_SET_VALUE:
                error = validateNumericString(action.value, { min: 6, max: 15, subject: 'ID Number' });
                return setIdNumberValid(error);

            case PASSPORT_SET_VALUE:
                error = validatePassportNumber(action.value, { min: 8, max: 15, required: true });
                return setPassportValid(error);
            case KRA_NUMBER_SET_VALUE:
                error = validateKraPinNumber(action.value);

                return setKraNumberValid(error);

            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Phone Number',
                    countryCode: gatsbyStack,
                });
                return setPhoneNumberValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case ID_DOC_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'ID Document',
                    required: true,
                });
                return setIdDocValid(error);

            case KRA_PIN_DOC_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'KRA PIN Document',
                    required: true,
                });
                return setKraPinValid(error);

            case PASSPORT_DOC_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Passport Document',
                    required: true,
                });
                return setPassportDocValid(error);

            case DOB_SET_VALUE:
                error = validateDateOfBirth(action.value, { min: 18, max: 85 });
                return setDOBValid(error);

            case AGE_BAND_SET_VALUE:
                error = validateSingleSelection(action.value, 'Age Band');
                return setAgeBandValid(error);

            case FULL_NAME_EMERGENCY_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'Full Name',
                });
                return setFullNameEmergencyValid(error);

            case PHONE_NUMBER_EMERGENCY_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Phone Number',
                    countryCode: gatsbyStack,
                });
                return setPhoneNumberEmergencyValid(error);

            case EMAIL_EMERGENCY_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailEmergencyValid(error);

            case REFERRED_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Referred By',
                });
                return setReferredValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
